/**
 * Classe genérica para o grid;
 * @author: Adalto Junior adalto@sagaranatech.com
 * Date: 16/07/2013
 */


Monet.Grid = Monet.Grid || {};

Monet.Grid.GenericGrid = function (container, dataProvider, columns, options) {
    var grid = null,
        checkboxSelector = null,
        entityToActionGrid = options.entityToActionGrid,
        entity = options.entity,
        checkBoxColumn = options.columnCheckBox,
        editColumn = options.columnEdit,
        editColumnSelector = null,
        headerMenuPlugin = null,
        headerMenuExists,
        headerMenuEventClassExists = false;

    options.enableCellNavigation = true;
    options.enableTextSelectionOnCells = true;
    options.sanitizer = (htmlString) => htmlString;

    var addBtnEventCheckBox = function () {
        try {
            const checkBoxEventClass = checkBoxColumn.checkBoxEventClass;
            const selector = (options.entity !== options.entityToActionGrid ? options.gridActionsSelector : "#" + entity + " .gridActions .MonetUIGridActions");
            for (let i = 0; i < checkBoxEventClass.length; i++) {
                const buttonCheckBox = new checkBoxEventClass[i]();
                buttonCheckBox.setEntity(entity);
                buttonCheckBox.setSelector( selector );
                buttonCheckBox.setScreenName("#" + entity);
                if(buttonCheckBox.setBtnSelector) {
                    buttonCheckBox.setBtnSelector(options.columnCheckBox.btnSelector);
                }

                buttonCheckBox.setValueBtn();
                buttonCheckBox.setClassName('btn-secondary');
                buttonCheckBox.init();
            }
        } catch (e) {
            const error = new Monet.Exception.ReturnError(this, "Error on add button event to check box.", e);
            error.console();
        }
    };

    var activeBtnToCheckBoxColumn = function () {
        if (checkBoxColumn?.show && checkBoxColumn?.checkBoxEventClass ) {
            addBtnEventCheckBox();
        }
    };

    var setActionsToGrid = function () {
        try {
            if (typeof options.actions !== "undefined" && options.actions.length > 0) {
                const gridActions = new Monet.Grid.Actions();
                gridActions.setEntity(entity);
                gridActions.setActions(options.actions);
                gridActions.setElement(options.gridActionsSelector || "#" + entity + ' .gridActions');
                gridActions.setGridSelector(options.gridContainner || "#" + entity + ' .gridContainer');
                gridActions.setEntityToActionGrid(entityToActionGrid);
                gridActions.setFieldsOverride(options.fieldsOverride);
                gridActions.init();
            }
        } catch (e) {
            const error = new Monet.Exception.ReturnError(this, "Erro on set actions to grid", e);
            error.console();
        }
    };

    const addCheckBoxColumn = function () {
        if (checkBoxColumn && checkBoxColumn?.show) {
            checkboxSelector = new Monet.Grid.ActionsModules.CheckBoxColumn(checkBoxColumn.options);
            columns.unshift(checkboxSelector.getColumn());
            options.frozenColumn++;
        }
    };

    const addEditColumn = function () {
        if (editColumn && editColumn.show) {
            editColumnSelector = new Monet.Grid.ActionsModules.EditColumn(entity);
            columns.unshift(editColumnSelector.getColumn());
            options.frozenColumn++;
        }
    };

    const addCustomColumns = () => {
        const customColumns = App.Forms[entity] && App.Forms[entity].customColumns;
        if (customColumns && customColumns.length > 0) {
            customColumns.forEach(column => {
                columns.unshift(column);
                options.frozenColumn++;
            });
        }
    }

    const activeCheckBoxColumnEvent = function (grid) {
        if (checkboxSelector !== null) {
            checkboxSelector.registerEvents(grid);
        }
    };

    var enableSaveGrid = function () {
        try {
            let selector = "#" + entity;
            const saveLayout = new Monet.Grid.ActionsModules.SaveGridLayout();
            saveLayout.setEntity(entity);

            if (options.selectorToGridActions) {
                selector = options.selectorToGridActions;
            }

            saveLayout.setSelector(selector);
            saveLayout.enableButtonToSave();
        } catch (e) {
            const error = new Monet.Exception.ReturnError(this, "Error on enble to save grid", e);
            error.console();
        }
    };

    var addEventScrollToGrid = function () {
        grid.pagination.setEntity(entity);
        grid.pagination.setListElement(grid.getViewportNode());
    };

    var sortGridByServer = function (e, args) {
        var columns = [],
            objColumn = null,
            optionsPagination = Monet.Grid.Utils.paginationOptions,
            data = "",
            dataView,

            addObjToSort = function ( field ) {
                objColumn = {field: null, order: null};

                var fieldInfo = field.sortCol.fieldInformation;
                var meta = (fieldInfo && fieldInfo.meta ? JSON.parse(fieldInfo.meta) : null);
                var columnToSort = '';

                if(meta && meta.hasMany){
                    if ( meta.hasMany.collectionName ){
                        columnToSort =  meta.hasMany.collectionName + '.' + meta.hasMany.entityName + '.' + (fieldInfo.lookupEntityColumn || meta.hasMany.lookupEntityColumn);
                    } else {
                        columnToSort = fieldInfo.name + '.' + fieldInfo.lookupEntityColumn;
                    }
                }

                objColumn.field = columnToSort || field.sortCol.field;
                objColumn.order = (field.sortAsc) ? "ASC" : "DESC";

                columns.push(objColumn);
            };

        if (args.multiColumnSort) {
            for (var i = 0; i < args.sortCols.length; i++) {
                addObjToSort(args.sortCols[i]);
            }
        } else {
            addObjToSort(args);
        }

        App.Forms[entity].columnToOrders = columns;

        App.Forms[entity].pagination.first = optionsPagination.FIRST;
        App.Forms[entity].pagination.max = optionsPagination.MAX_RESULT;

        if (App.Objects[entity] && App.Objects[entity].getFilter) {
            data = App.Objects[entity].getFilter();
        }

        dataView = App.Forms[entity].dataProvider;
        dataView.arrayIds = [];

        grid.removeScrollToGrid();

        var customFilter = App.Forms[entity].filterBuilder;
        if(customFilter){
            customFilter.executeFilter() ;
        } else {
            App.Objects[entity].updateGrid(data, Monet.Grid.addDataToGrid);
        }
    };

    var sortGridOnClient = function (e, args) {
        var cols = args.sortCols;
        var comparer = function (dataRow1, dataRow2) {

            for (var i = 0, l = cols.length; i < l; i++) {
                var result;
                var field = cols[i].sortCol.field;
                var sign = cols[i].sortAsc ? 1 : -1;
                var value1 = dataRow1[field];
                var value2 = dataRow2[field];

                if (typeof value1 === 'undefined') {
                    value1 = '';
                }

                if (typeof value2 === 'undefined') {
                    value2 = '';
                }

                result = (value1 === value2 ? 0 : (value1 > value2 ? 1 : -1)) * sign;
                if (result !== 0) {
                    return result;
                }
            }
            return 0;
        };

        dataProvider.sort(comparer);

        grid.invalidate();
        grid.render();
    };

    addCustomColumns();
    addEditColumn();
    addCheckBoxColumn();
    setActionsToGrid();

    grid = new Slick.Grid(container, dataProvider, columns, options);
    grid.pagination = new Monet.Grid.ActionsModules.ScrollPagination();

    App.Forms[entity] = App.Forms[entity] || {};

    App.Forms[entity].table = grid;

    headerMenuExists = typeof options.headerMenu !== "undefined";

    if (headerMenuExists) {

        headerMenuEventClassExists = typeof options.headerMenu.headerMenuEventClass !== "undefined";

        if (headerMenuEventClassExists) {

            var entityToAggregate = null;
            var selector = "#" + entity;

            if (options.entityToActionGrid) {
                entityToAggregate = entityToActionGrid;
            }

            if (options.gridContainner) {

                selector = options.gridContainner;

            }

            headerMenuPlugin = new options.headerMenu.headerMenuEventClass(entity, selector, entityToAggregate);

        }
    }

    grid.getEntity = function () {
        return entity;
    };

    grid.getObjectScroll = function () {
        return grid.pagination;
    };

    grid.getColumnByFieldId = function (fieldId) {

        var error = null,
            columns = null,
            columnsLength = 0,
            column = null;

        try {

            if (fieldId) {

                columns = grid.getColumns();
                columnsLength = columns.length;

                for (var i = 0; i < columnsLength; i++) {

                    if (fieldId === columns[i].fieldId) {

                        column = columns[i];
                        break;
                    }

                }

                return column;
            }


        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on get column by field Id", e);
            error.console();

        }
    };

    grid.getColumnByFieldName = function (fieldName) {

        var error = null,
            columns = null,
            columnsLength = 0,
            column = null;

        try {

            if (typeof fieldName !== "undefined") {

                columns = grid.getColumns();
                columnsLength = columns.length;

                for (var i = 0; i < columnsLength; i++) {

                    if (fieldName === columns[i].field) {

                        column = columns[i];
                        break;
                    }

                }

                return column;
            }


        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on get column by field Id", e);
            error.console();

        }
    };

    grid.getColumnIdByCellNumber = function (cell) {

        var columns = grid.getColumns();
        var column = columns[cell];
        var columnId;

        if (column.id){
            columnId = column.id;
        }

        return columnId;

    };

    grid.onDragEnd.subscribe(function () {
        enableSaveGrid();
    });

    grid.onColumnsResized.subscribe(function () {
        enableSaveGrid();
    });

    grid.onColumnsReordered.subscribe(function () {
        enableSaveGrid();
    });

    grid.onSort.subscribe(function (e, args) {

        var error = null;

        try {
            const sortBy = App.Forms[entity]?.table?.sortBy || options.sortBy;

            if (sortBy === 'client') {
                sortGridOnClient(e, args);
            } else {
                sortGridByServer(e, args);
            }

        } catch (stack) {

            error = new Monet.Exception.ReturnError(this, "Error on sort grid", stack);
            error.console();
        }

    });

    grid.getColumnSizeByFieldId = function (fieldId) {

        var error = null,
            column = null;

        try {

            column = this.getColumnByFieldId(fieldId);

            if (column) {
                return column.width;
            }

            return column;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on get column size by field id", e);
            error.console();

        }
    };


    grid.getColumnByFieldName = function (fieldName) {

        var error = null,
            columns = null,
            columnsLength = 0,
            column = null;

        try {

            if (typeof fieldName !== "undefined") {

                columns = grid.getColumns();
                columnsLength = columns.length;

                for (var i = 0; i < columnsLength; i++) {

                    if (fieldName === columns[i].field) {

                        column = columns[i];
                        break;
                    }

                }

                return column;
            }


        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on get column by field Id", e);
            error.console();

        }
    };


    grid.removeScrollToGrid = function () {

        var error = null;

        try {

            grid.onScroll.unsubscribe(grid.pagination.scrollEventListenerFunction);

        } catch (e) {

            error = new Monet.Exception.ReturnError(this, "Error on remove scroll to grid", e);
            error.console();

        }

    };

    grid.addScrollToGrid = function () {

        var error = null;

        try {
            let timeoutId;
            const listener = () => {
                timeoutId && clearTimeout(timeoutId);
                timeoutId = setTimeout(grid.pagination.scrollEventListenerFunction, 100);
            }

            grid.onScroll.unsubscribe(listener);
            grid.onScroll.subscribe(listener);
        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on add scroll to grid", e);
            error.console();

        }

    };

    grid.getContainerNode = function () {
        return $(container)[0];
    };

    grid.getItemsSelected = function () {

        var rowSelected = grid.getSelectedRows();
        var itemsSelected = [];

        for (var i = 0, j = rowSelected.length; i < j; i++) {
            itemsSelected.push(grid.getDataItem(rowSelected[i]).model);
        }

        return itemsSelected;

    };

    var initialize = function () {

        var tabName = Monet.Utils.GetTabName();
        const tab = document.querySelector(`.gmTabs__tab span[data-live-key="${tabName}"]`);

        if (checkBoxColumn?.show || options?.selecteRows) {
            grid.setSelectionModel(new Slick.RowSelectionModel());
        }

        if (headerMenuPlugin !== null) {
            grid.registerPlugin(headerMenuPlugin);
        }

        addEventScrollToGrid();
        activeCheckBoxColumnEvent(grid);
        activeBtnToCheckBoxColumn();

        if(tab) {
            tab.parentNode.addEventListener('click', (function (grid) {
                return function () {
                    setTimeout((function (){
                        return function () {
                            grid.resizeCanvas ();
                            grid.invalidate();
                        };
                    }(grid)), 300);
                };
            }(grid)));
        }

        let timeoutId;
        window.addEventListener("resize", () => {
          timeoutId && clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            const tabActive = document.querySelector(
              ".gmTabs__panel.is-active > div#" + tabName
            );
            if (tabActive) {
              grid.resizeCanvas();
              grid.invalidate();
            }
          }, 500);
        });


        const resizeListener = () => {
            const proGrid = document.querySelector('#routeDetailPRO');
            if (proGrid && proGrid.style.display === "block") {
                App.Views.RouteDetails.adjustProGridFooter();
            }
        }
        if (!window.resizeListenerAdded) {
            let timeoutId;
            window.resizeListenerAdded = true;
            window.addEventListener("resize", () => {
                timeoutId && clearTimeout(timeoutId);
                timeoutId = setTimeout(resizeListener, 500);
            });
        }

    };

    initialize();

    return grid;

};